import { ProjectOnboardingRepositoryDTO } from '../../domain/onboarding/ProjectOnboardingRepositoryDTO';
import { Project } from '../../domain/project/Project';
import { ProjectPlannerMapper } from '../project/ProjectPlannerMapper';

export class ProjectOnboardingMapper {
  static toRepository(project: Project): ProjectOnboardingRepositoryDTO {
    return {
      geo_fences_enabled: project.geo_fences_enabled,
      planner: ProjectPlannerMapper.toRepository(project.planner),
      time_zone: project.time_zone,
    };
  }
}
